import { render, staticRenderFns } from "./RefileFollowup.vue?vue&type=template&id=766bffab&scoped=true&"
import script from "./RefileFollowup.vue?vue&type=script&lang=js&"
export * from "./RefileFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766bffab",
  null
  
)

export default component.exports